import { createFeatureSelector, createSelector } from "@ngrx/store";
import { State, InvoiceUploadWidgetAdapter, InvoiceUploadInstance } from '@invoice-upload/reducers/invoice-upload.reducers';
export const selectInvoiceUploadState = createFeatureSelector<State>('invoiceUploads');

export const {
  selectIds,
  selectEntities,
  selectAll: selectAllDiaryWidgetsData,
  selectTotal,
} = InvoiceUploadWidgetAdapter.getSelectors(selectInvoiceUploadState);

export const selectEntityByWidgetConfigId = (widgetConfigurationId: number) => createSelector(selectEntities, (entities) => entities[widgetConfigurationId.toString()]);


export function getInvoices(widgetConfigurationId: number) {
  return createSelector([selectEntityByWidgetConfigId(widgetConfigurationId)],
    (invoiceUploadInstance: InvoiceUploadInstance) => {
      return invoiceUploadInstance.invoices;
    });
}
